import EventMixin from './EventMixin';
import EventType from '../types/EventTypes';

export default {
  data: () => ({
    isEventFullyBooked: false,
  }),
  mixins: [EventMixin],
  computed: {
    registrationLinkText() {
      return this.isEventFullyBooked
        ? this.translate('lblEventRegisterForQueue')
        : this.translate('lblEventRegister');
    },
    isRegistrationMandatory() {
      return this.event?.eventType === EventType.EVENT_WITH_REGISTRATION;
    },
    isMyKwsAccountMandatory() {
      return this.event?.eventType === EventType.EVENT_WITH_MY_KWS_REGISTRATION;
    },
  },
  methods: {
    async initIsEventFullyBooked(apiUrl, eventId) {
      await this.getEventData(`${apiUrl}/campaign/events/event/capacity/${eventId}`)
        .then((response) => { this.isEventFullyBooked = response?.data?.info?.EventFreeCapacity__c <= 0; });
    },
  },
};
